import { Image, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

interface WhatToExpectRowProps {
  index: number
  imageSrc: string
  title: string
  description: string
}

const WhatToExpectRow = ({
  imageSrc,
  title,
  description,
}: WhatToExpectRowProps) => (
  <div className="flex items-start">
    <div className="w-1/8">
      <Image src={imageSrc} alt={title} />
    </div>
    <div className="w-7/8 -ml-7">
      <Text variant={TypographyStyles.H3} className="mb-2">
        {title}
      </Text>
      <Text variant={TypographyStyles.BODY_SM}>{description}</Text>
    </div>
  </div>
)

export const WhatToExpectContent = ({
  title,
  subtitle,
  whatToExpectRows,
}: {
  title: string
  subtitle: string
  whatToExpectRows: WhatToExpectRowProps[]
}) => (
  <div className="space-y-4">
    <Text variant={TypographyStyles.H2} className="mb-2">
      {title}
    </Text>
    <Text variant={TypographyStyles.BODY_XS}>{subtitle}</Text>
    {whatToExpectRows.map((row) => (
      <WhatToExpectRow key={row.index} {...row} />
    ))}
  </div>
)
